<template>
    <div class='post-price-offer-project-action'>
        <button @click="showModal = true" type="button" class="button is-primary">Afslut projekt</button>

        <b-modal :active="showModal" :canCancel="['escape']">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">Afslut projekt</p>
                </header>

                <section class="modal-card-body">
                    <p>For at afslutte projektet skal du blot trykke på "Afslut projekt".</p>
                    <br>

                    <template v-if="project.price_type === 'hourly'">
                        <p>For at udregne dit endelige projekts pris korrekt skal du indtaste hvor mange timer du har brugt herunder.</p>
                        <br>

                        <b-field label="Timer brugt"
                                 :type="{'is-danger': veeErrors.has('hours')}"
                                 :message="veeErrors.first('hours')">
                            <b-input v-model="hours" type="number" name="hours"
                                     v-validate="'required|numeric'" :data-vv-as="'Timeforbruget'" >
                            </b-input>
                        </b-field>
                    </template>
                </section>

                <footer class="modal-card-foot content-pulled-right">
                    <button class="button" @click="showModal = false" type="button">{{$t('global.actions.back')}}</button>

                    <button class="button is-primary" :class="{'is-loading': isSubmitting}" @click="submit" :disabled="veeErrors.any()">Afslut projekt</button>
                </footer>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import ProjectService from '@/taskflex/projects/services/ProjectService';

    export default {
        data() {
            return {
                showModal: false,
                isSubmitting: false,
                hours: null,
            };
        },

        props: {
            project: {
                type: Object,
                required: true,
            },
        },

        mounted() {
            if (this.project.price_type === 'hourly') {
                this.hours = this.project.hours_used;
            }
        },

        methods: {
            async submit() {
                if (!await this.$validator.validateAll()) {
                    return;
                }

                const options = {
                    hours: this.hours,
                };

                this.isSubmitting = true;

                ProjectService.finalize(this.project.id, options, ({ data }) => {
                    this.isSubmitting = false;
                    this.showModal = false;

                    this.$emit('finalized', data);
                });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/conversations/components/Projects/ProjectActions/FinalizeProjectAction.vue